import PersonalCenter from '@/view/personalCenter/PersonalCenter.vue'
import BasicLayout from '@/view/BasicLayout.vue'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

export const asyncPersonRouterMap = [
  {
    path: '/',
    component: BasicLayout,
    redirect: '/home',
    children: [{
      path: '/personalCenter',
      redirect: '/personalCenter/baseInfo',
      component: PersonalCenter,
      children: [
        {
          path: '/personalCenter/baseInfo',
          redirect: '/personalCenter/baseInfo/person',
          component: RouteView,
          meta: { title: '基础信息', icon: 'info-circle' },
          children: [
            {
              path: '/personalCenter/baseInfo/person',
              component: () => import('@/view/personalCenter/baseInfo/personInfo/PersonInfo'),
              meta: { title: '个人信息' },
            },
            {
              path: '/personalCenter/baseInfo/verify',
              component: () => import('@/view/personalCenter/baseInfo/verifyCenter/VerifyCenter'),
              meta: { title: '认证中心' },
            }
          ]
        },
        {
          path: '/personalCenter/tenant',
          redirect: '/personalCenter/tenant/signup',
          component: RouteView,
          meta: { title: '我是承租方', icon: 'user' },
          children: [
            {
              path: '/personalCenter/tenant/signup',
              component: () => import('@/view/personalCenter/tenant/Signup'),
              meta: { title: '我的报名' },
            },
            // {
            //   path: '/personalCenter/tenant/quotation',
            //   component: () => import('@/view/personalCenter/tenant/Quotation'),
            //   meta: { title: '我的报价' },
            // }
          ]
        },
        {
          path: '/personalCenter/others',
          redirect: '/personalCenter/others/follow',
          component: RouteView,
          meta: { title: '其他', icon: 'credit-card' },
          children: [
            {
              path: '/personalCenter/others/follow',
              component: () => import('@/view/personalCenter/others/Follow'),
              meta: { title: '我的关注' },
            }
          ]
        },
      ]
    }]
  }]

export const asyncCompanyRouterMap = [
  {
    path: '/',
    component: BasicLayout,
    redirect: '/home',
    children: [{
      path: '/personalCenter',
      redirect: '/personalCenter/baseInfo',
      component: PersonalCenter,
      children: [
        {
          path: '/personalCenter/baseInfo',
          redirect: '/personalCenter/baseInfo/company',
          component: RouteView,
          meta: { title: '基础信息', icon: 'info-circle' },
          children: [
            {
              path: '/personalCenter/baseInfo/company',
              component: () => import('@/view/personalCenter/baseInfo/CompanyInfo'),
              meta: { title: '企业信息' },
            },
          ]
        },
        {
          path: '/personalCenter/landlord',
          redirect: '/personalCenter/landlord/myRental',
          component: RouteView,
          meta: { title: '我是出租方', icon: 'home' },
          children: [
            {
              path: '/personalCenter/landlord/myRental',
              redirect: '/personalCenter/landlord/myRental/rights',
              component: RouteView,
              meta: { title: '我的招租' },
              children: [
                {
                  path: '/personalCenter/landlord/myRental/rights',
                  component: () => import('@/view/personalCenter/landlord/rights/Rights'),
                  meta: { title: '权证管理' },
                },
                {
                  path: '/personalCenter/landlord/myRental/resources',
                  component: () => import('@/view/personalCenter/landlord/resources/Resources'),
                  meta: { title: '房源管理' },
                },
                {
                  path: '/personalCenter/landlord/myRental/bidApply',
                  component: () => import('@/view/personalCenter/landlord/bidApply/BidApply'),
                  meta: { title: '进场公开招租申请' },
                },
                {
                  path: '/personalCenter/landlord/myRental/intentRelease',
                  component: () => import('@/view/personalCenter/landlord/IntentRelease'),
                  meta: { title: '意向发布项目登记' },
                },
              ],
            },
            {
              path: '/personalCenter/landlord/myProject',
              redirect: '/personalCenter/landlord/myProject/publicBid',
              component: RouteView,
              meta: { title: '我的项目' },
              children: [
                {
                  path: '/personalCenter/landlord/myProject/publicBid',
                  component: () => import('@/view/personalCenter/landlord/PublicBid'),
                  meta: { title: '进场公开招租' },
                },
                {
                  path: '/personalCenter/landlord/myProject/intentProjects',
                  component: () => import('@/view/personalCenter/landlord/IntentProjects'),
                  meta: { title: '意向发布项目' },
                },
              ],
            },
            {
              path: '/personalCenter/landlord/contracts',
              component: () => import('@/view/personalCenter/landlord/Contracts'),
              meta: { title: '合同备案' },
            },
          ]
        },
        {
          path: '/personalCenter/tenant',
          redirect: '/personalCenter/tenant/signup',
          component: RouteView,
          meta: { title: '我是承租方', icon: 'user' },
          children: [
            {
              path: '/personalCenter/tenant/signup',
              component: () => import('@/view/personalCenter/tenant/Signup'),
              meta: { title: '我的报名' },
            },
            // {
            //   path: '/personalCenter/tenant/quotation',
            //   component: () => import('@/view/personalCenter/tenant/Quotation'),
            //   meta: { title: '我的报价' },
            // }
          ]
        },
        {
          path: '/personalCenter/others',
          redirect: '/personalCenter/others/follow',
          component: RouteView,
          meta: { title: '其他', icon: 'credit-card' },
          children: [
            {
              path: '/personalCenter/others/follow',
              component: () => import('@/view/personalCenter/others/Follow'),
              meta: { title: '我的关注' },
            }
          ]
        },
      ]
    }]
  }]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/view/home/Index')
      },
      {
        path: '/publicRental',
        name: 'publicRental',
        component: () => import('@/view/houseList/AllHouse')
      },
      {
        path: '/intentionRental',
        name: 'intentionRental',
        component: () => import('@/view/houseList/Shop')
      },
      {
        path: '/info',
        name: 'info',
        component: () => import('@/view/info/Index')
      },
      {
        path: '/marketService',
        name: 'marketService',
        component: () => import('@/view/marketService/Index')
      },
      {
        path: '/investmentPromotionCenter',
        name: 'investmentPromotionCenter',
        component: () => import('@/view/investmentPromotionCenter/Index')
      },
      // {
      //   path: '/platformIntroduction',
      //   name: 'platformIntroduction',
      //   component: () => import('@/view/platformIntroduction/Index')
      // },
      {
        path: '/houseDetail',
        name: 'houseDetail',
        component: () => import('@/view/houseDetail/Index'),
        props($route) {
          return {
            assetId: $route.query.assetId
          }
        }
      },
      {
        path: '/allHouse',
        name: 'allHouse',
        component: () => import('@/view/houseList/AllHouse')
      },
      {
        path: '/mapFindHouse',
        name: 'mapFindHouse',
        component: () => import('@/view/houseList/MapFindHouse')
      },
      {
        path: '/helpFindHouse',
        name: 'helpFindHouse',
        component: () => import('@/view/helpFindHouse/HelpFindHouse')
      },
      {
        path: '/servicePoint',
        name: 'servicePoint',
        component: () => import('@/view/servicePoint/ServicePoint')
      },
      {
        path: '/shop',
        name: 'shop',
        component: () => import('@/view/houseList/Shop')
      },
      {
        path: '/factory',
        name: 'factory',
        component: () => import('@/view/houseList/Factory')
      },
      {
        path: '/officeBuilding',
        name: 'officeBuilding',
        component: () => import('@/view/houseList/OfficeBuilding')
      },
    ]
  },
]
